// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"bdd8c586","311":"6a25f545","330":"0f9ac4bd","453":"e40de072"}[chunkId] + ".chunk.js";
};